module.exports = __webpack_public_path__ + "static/media/question.f4347d28.png";